import API from 'shared/lib/api'

export default {

  // Fetches resources from the API.
  //
  // @example
  //   SomeModel.actions.fetchAll({ page: 2 });
  //
  actionMethod: (model, options = {}) => {
    options.apiVersion = options.apiVersion ?? model.options.apiVersion

    if (!options.stats) {
      options.stats = { total: 'count' }
    } else {
      options.stats.total = 'count'
    }

    return API.getCollection(model.pluralName, options)
  },

  // Updates flags on collection.
  //
  reduceMethod: (model, collection, action) => {
    switch (action.type) {
      case model.actionTypes.FETCH_ALL_START:
        return collection.set('isLoadingCollection', true)

      case model.actionTypes.FETCH_ALL_ERROR:
        return collection.set('isLoadingCollection', false)

      case model.actionTypes.FETCH_ALL_SUCCESS:
        return collection.set('isLoadingCollection', false)
    }
  }
}
